import { render, staticRenderFns } from "./InfosetFiltersHeader.vue?vue&type=template&id=81f0ffe2&scoped=true&"
import script from "./InfosetFiltersHeader.vue?vue&type=script&lang=ts&"
export * from "./InfosetFiltersHeader.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetFiltersHeader.vue?vue&type=style&index=0&id=81f0ffe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f0ffe2",
  null
  
)

export default component.exports